import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})

export class TranslationService {
    constructor(private translateService: TranslateService) { }

    getTranslation(str: string, data: Record<string, any> = {}): string {
        let result: string = '';
        this.translateService.get(str, data).subscribe((translation: string) => {
            result = translation;
        })

        return result;
    }
}